import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'common/lazy';

import { useClassName } from 'common/hooks';

import './form-login-gate.less';

const DEFAULT_MESSAGE = 'Create an account or log in to fill out this form.';

const FormLoginGate = ({ signupUrl, loginUrl, message }) => {
  const classNames = useClassName('FormLoginGate');

  return (
    <div className={classNames('container')}>
      <p className={classNames('message')}>{message || DEFAULT_MESSAGE}</p>
      <Button as={Link} to={signupUrl} primary size="large">
        Create an account
      </Button>
      <p className={classNames('login')}>
        Already have an account? <Link to={loginUrl}>Log in</Link>
      </p>
    </div>
  );
};

FormLoginGate.propTypes = {
  signupUrl: PropTypes.string.isRequired,
  loginUrl: PropTypes.string.isRequired,
  message: PropTypes.string,
};

export default FormLoginGate;
